import { VIDEO_FORMATS } from "./constants";

export const isVideo = (type = "") => {
  return VIDEO_FORMATS.includes(type.toLowerCase());
}